'use strict';
var arrayUniq = require('array-uniq');

module.exports = function () {
	return arrayUniq([].concat.apply([], arguments));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/array-union/index.js
// module id = SJ4O
// module chunks = 0